export const environment = {
    production: true,
    path: 'api-dev.spazio-zero.com',
    host: 'https://api-dev.spazio-zero.com/api'
  };